import { Textarea as UITextarea } from "@webmotors/eleanor-ui";
import type { ChangeEvent, HTMLAttributes } from "react";

export type TextareaStatus =
  | "disabled"
  | "validated"
  | "error"
  | "filled"
  | "focused"
  | "default";

export interface TextareaProps extends HTMLAttributes<HTMLTextAreaElement> {
  name?: string;
  height?: string;
  labelText?: string;
  auxText?: string;
  state?: TextareaStatus;
  verticalResize?: boolean;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string;
}

export function Textarea({ ...props }: Readonly<TextareaProps>) {
  return <UITextarea {...props} />;
}
